<template>
  <div class="block-chain-cipher-retrieval">
    <action-bar>
      <search
        v-model="inputContent"
        :disabled="!$utils.hasAuth($store, auth.blockchain.checkDetail.onChainRetrieval.retrieval)"
        placeholder="关键字只支持中文，多个关键字用','隔开"
        @onSearch="submit"
      ></search>
    </action-bar>
    <detail-section title="检索结果">
      <normal-table
        ref="commonTable"
        :table-col="tableCol"
        :table-data="list"
        :operator="operator"
        :show-edit="true"
        :paging="paging"
        :show-pagination="false"
      >
      </normal-table>
    </detail-section>
    <ciphertext-detail ref="ciphertextDetail"></ciphertext-detail>
  </div>
</template>

<script>
import ciphertextDetail from './ciphertextDetail'
import auth from '@/auth/index'

export default {
  name: 'Index',
  components: {
    ciphertextDetail
  },
  data() {
    return {
      keywordsText: '',
      paging: {
        total: 0
      },
      inputContent: '',
      tableCol: [
        {
          prop: 'create_time',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row)
          },
          minWidth: 158
        },
        {
          prop: 'policy', //策略
          label: '策略',
          minWidth: 258
        },
        {
          prop: 'cipher_data', //密文
          label: '密文',
          minWidth: 558
        }
      ],
      operator: [
        {
          text: '显示',
          showText: true,
          icon: 'icon-check',
          click: (row, col, cellValue) => {
            return this.handleShow(row)
          }
        }
      ],
      operateCol: {
        minWidth: 102
      },
      list: [],
      formDate: {},
      auth: auth
    }
  },
  methods: {
    submit() {
      const userID = String(JSON.parse(localStorage.getItem('userID')))
      let params = {}
      params.user_id = userID
      this.keywordsText = this.inputContent
      params.key_words = this.keywordsText.split(',')
      this.$apis.chain
        .searchData(params)
        .then(res => {
          const newArrar = res.data.items.map(item => {
            item.cipher_data = item.cipher_data.substring(0, 200)
            return item
          })

          this.paging.offset = 0
          this.paging.limit = 10
          this.paging.total = newArrar.length

          this.list = newArrar
          this.$message.success('查询成功')
        })
        .catch(err => {
          return
        })
    },
    handleShow(row) {
      const userID = JSON.parse(localStorage.getItem('userID'))
      let params = {}
      params.data_id = String(row.id)
      params.user_id = userID
      this.$apis.chain
        .searchDecrypt(params)
        .then(res => {
          if (res.data) {
            this.$message.success('查询成功')
            this.$refs.ciphertextDetail.handleOpen(res)
          } else {
            this.$message.error('该用户没有权限访问')
          }
        })
        .catch(err => {
          return
        })
    },
    formatTime(row) {
      // 处理时间格式：2025-10-13 16:12:49.464 +0800 CST
      let timeStr = row.create_time
      if (timeStr && timeStr.includes('CST')) {
        // 移除 CST 时区标识，保留标准格式
        timeStr = timeStr.replace(' CST', '').replace(' +0800', '')
      }
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM:SS', timeStr)
    },
    refresh() {}
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'block-chain-cipher-retrieval',
  (
    --block-chain-cipher-retrieval-operate-color: #45c2ff
  ),
  (
    --block-chain-cipher-retrieval-operate-color: #45c2ff
  )
);
.block-chain-cipher-retrieval {
  @include adaptation(
    (
      --block-chain-cipher-retrieval-form-width: 365px,
      --block-chain-cipher-retrieval-unavaliable-height: 218px,
      --block-chain-cipher-retrieval-detail-section-content-padding: 4px 0 0,
      --block-chain-cipher-retrieval-detail-section-padding: 4px 0 0
    )
  );
  --block-chain-cipher-retrieval-min-height: calc(
    var(--base-main-router-body-avaliable-height) -
      var(--block-chain-cipher-retrieval-unavaliable-height)
  );

  .cbaas-search-wrap {
    width: var(--block-chain-cipher-retrieval-form-width);
  }

  .cbaas-detail-section {
    padding: var(--block-chain-cipher-retrieval-detail-section-padding);
    /deep/ .content {
      padding: var(--block-chain-cipher-retrieval-detail-section-content-padding);
    }
  }

  .normal-table-wrap {
    height: 100%;
    min-height: var(--block-chain-cipher-retrieval-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--block-chain-cipher-retrieval-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--block-chain-cipher-retrieval-min-height);

        .operate-item {
          color: var(--block-chain-cipher-retrieval-operate-color);
        }
      }
    }
  }
}
</style>
